import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

export const SIDEBAR_COLLAPSED_WIDTH = 70;
export const COLLAPSED_ICON_SIZE = 44;

export function CollapsedSidebarItem({ children }) {
  return (
    <Flex
      w="100%"
      justify="center"
      align="center"
      flexShrink={0}
    >
      {children}
    </Flex>
  );
}

export const CollapsedIconButton = React.forwardRef(function CollapsedIconButton(
  { children, sx, ...props },
  ref,
) {
  return (
    <Box
      ref={ref}
      as="button"
      type="button"
      display="flex"
      alignItems="center"
      justifyContent="center"
      w={`${COLLAPSED_ICON_SIZE}px`}
      h={`${COLLAPSED_ICON_SIZE}px`}
      minW={`${COLLAPSED_ICON_SIZE}px`}
      maxW={`${COLLAPSED_ICON_SIZE}px`}
      minH={`${COLLAPSED_ICON_SIZE}px`}
      p={0}
      m={0}
      border="none"
      borderRadius="12px"
      lineHeight={0}
      cursor="pointer"
      {...props}
      sx={{
        width: `${COLLAPSED_ICON_SIZE}px !important`,
        minWidth: `${COLLAPSED_ICON_SIZE}px !important`,
        maxWidth: `${COLLAPSED_ICON_SIZE}px !important`,
        justifyContent: 'center !important',
        alignItems: 'center !important',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
});

export const collapsedIconInnerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: '20px',
  h: '20px',
  margin: 0,
  '& svg, & .chakra-icon': {
    w: '20px !important',
    h: '20px !important',
    margin: '0 !important',
  },
};
